import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AdminAddDashboardsList from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboardsList/AdminAddDashboardsList';

import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';
import { type FC } from 'react';

const AdminAddDashboardsAreas: FC = () => {
  const { areas } = useAreaContext();

  if (!areas) return <></>;

  return (
    <>
      <Typography variant="h3" sx={{ paddingRight: '40px' }}>
        Areas
      </Typography>
      <Box>
        <AdminAddDashboardsList
          items={areas}
          navigateURL={(id: string) => `/admin/add-dashboards/areas/${id}`}
          actions={{
            add: false,
            edit: false,
            delete: false,
          }}
        />
      </Box>
    </>
  );
};

export default AdminAddDashboardsAreas;
